import React, { useState, useEffect } from 'react';

const Avatar = ({
  src,
  name,
  size = 44,
  fontSize,
  bg = 'var(--orange-3)',
  color = 'var(--orange-10)',
  className,
  style,
}) => {
  const [errored, setErrored] = useState(false);

  // Reset on src change so a new url retries
  useEffect(() => { setErrored(false); }, [src]);

  const initial = (name || '').trim().charAt(0).toUpperCase() || '?';
  const dimensions = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    flexShrink: 0,
  };

  if (src && !errored) {
    return (
      <img
        src={src}
        alt={name || ''}
        className={className}
        onError={() => setErrored(true)}
        style={{ ...dimensions, objectFit: 'cover', display: 'block', ...style }}
      />
    );
  }

  return (
    <div
      className={className}
      style={{
        ...dimensions,
        backgroundColor: bg,
        color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: fontSize || `${Math.max(12, Math.round(size * 0.4))}px`,
        fontWeight: 700,
        ...style,
      }}
    >
      {initial}
    </div>
  );
};

export default Avatar;
